/**
 * Pincode lookup using the free India Post API.
 * Returns { city, state, district } or null on failure.
 *
 * API: https://api.postalpincode.in/pincode/{pincode}
 * Rate limit: none documented, but we debounce on the caller side.
 */
export async function lookupPincode(pincode) {
  if (!pincode || pincode.length !== 6 || !/^\d{6}$/.test(pincode)) {
    return null;
  }

  try {
    const res = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
    if (!res.ok) return null;

    const data = await res.json();
    if (!Array.isArray(data) || data[0]?.Status !== 'Success' || !data[0]?.PostOffice?.length) {
      return null;
    }

    const po = data[0].PostOffice[0];
    return {
      city: po.District || po.Division || '',
      state: po.State || '',
      district: po.District || '',
    };
  } catch {
    return null;
  }
}
